export default function Pol({ lang }) {
    return(
        <div className="text-justify">
            <h1>
                ЗАПРЕЩЕННЫЕ ТОВАРЫ И УСЛУГИ
            </h1>
            <p>
                На платформе запрещено размещать и продавать:
            </p>
            <ol>
                <li>
                    материалы, нарушающие законодательство РФ или права третьих лиц;
                </li>
                <li>
                    документы, содержащие персональные данные без согласия;
                </li>
                <li>
                    астрологические, эзотерические, медицинские и юридические услуги без соответствующих лицензий;
                </li>
                <li>
                    файлы, не содержащие ценности (пустые документы, ссылки, бессмысленный текст);
                </li>
                <li>
                    материалы с рекламой, скрытой подпиской или вредоносным кодом.
                </li>
            </ol>
            <p>
                Полный перечень запрещённых товаров и услуг — в соответствии с правилами Т-банка:
                <a href="https://acdn.tinkoff.ru/static/documents/bc8d874b-99d0-436c-b556-9d6b313110b8.pdf" target="_blank" rel="noopener noreferrer">
                    https://acdn.tinkoff.ru/static/documents/bc8d874b-99d0-436c-b556-9d6b313110b8.pdf
                </a>
            </p>
        </div>
    );
}